import {
  Form, Grid, Link,
} from '@domain-group/suit-theme'

import useBulkSelectImages from '@modals/BulkSelectImagesModal/hooks/useBulkSelectImages'

import type { ImageModel } from '@models/types'

import Thumbnail from './Thumbnail'

const tileSizes = {
  large: {
    width: 320,
    height: 200,
  },
  small: {
    width: 150,
    height: 110,
  },
}

const fullScreenGridTemplateColumns = {
  large: 'repeat(2, 1fr)',
  small: 'repeat(3, 1fr)',
}

const sortImagesById = (images: ImageModel[], sortOrder: 'newest' | 'oldest') => (
  [...images].sort((imageA, imageB) => (sortOrder === 'newest' ? imageB.id - imageA.id : imageA.id - imageB.id))
)

interface ImagesProps {
  bulkSelectImagesPayload: ReturnType<typeof useBulkSelectImages>,
  fullScreen: boolean,
  setViewMode: (viewMode: 'small' | 'large') => void,
  sortOrder: 'newest' | 'oldest',
  viewMode: 'small' | 'large',
}

const ImagesView = (props: ImagesProps) => {
  const {
    bulkSelectImagesPayload, fullScreen, setViewMode, sortOrder, viewMode,
  } = props

  const {
    callbacks: { selectId },
    deletedImageIds,
    filteredImages,
    selectedEntityIds,
  } = bulkSelectImagesPayload

  const images = fullScreen ? sortImagesById(filteredImages, sortOrder) : filteredImages

  const tileSize = tileSizes[viewMode] || {}

  const gridTemplateColumns = fullScreen
    ? fullScreenGridTemplateColumns[viewMode]
    : `repeat(auto-fill, minmax(${tileSize.width}px, 1fr))`

  return (
    <Form.Field
      direction="column"
      label={fullScreen ? undefined : 'Images'}
      labelRight={fullScreen ? undefined : (
        <Link
          onClick={() => setViewMode(viewMode === 'large' ? 'small' : 'large')}
          textProps={{ fontSize: 'xsmall' }}
        >
          {viewMode === 'large' ? 'View Small Tiles' : 'View Large Tiles'}
        </Link>
      )}
    >
      <Grid
        // @ts-expect-error TS2322
        gridGap="medium"
        gridAutoRows={fullScreen ? undefined : '1fr'}
        gridTemplateColumns={gridTemplateColumns}
        gridTemplateRows={fullScreen ? undefined : `repeat(auto-fill, minmax(${tileSize.height}px, 1fr))`}
      >
        {images.map((image) => {
          const selectionIndex = selectedEntityIds.findIndex(id => image.id === id)

          return (
            <Thumbnail
              callbacks={{ selectImageId: selectId }}
              fullScreen={fullScreen}
              key={image.id}
              image={image}
              selectionIndex={selectionIndex}
              viewMode={viewMode}
            />
          )
        })}

        {deletedImageIds.map((deletedImageId) => {
          const selectionIndex = selectedEntityIds.findIndex(id => deletedImageId === id)

          return (
            <Thumbnail
              callbacks={{ selectImageId: selectId }}
              fullScreen={fullScreen}
              key={deletedImageId}
              // @ts-expect-error TS2739
              image={{ id: deletedImageId }}
              selectionIndex={selectionIndex}
              viewMode={viewMode}
            />
          )
        })}
      </Grid>
    </Form.Field>
  )
}
export default ImagesView
